import LocationPickerField from '../../../../Direcciones/LocationPickerField';

const fields = [
  { key: 'tipoVia', label: 'TIPO DE VÍA', type: 'select' },
  { key: 'nombreVia', label: 'NOMBRE DE VÍA', type: 'text', placeholder: 'Ej: LOS LAURELES', autoComplete: 'address-line1' },
  { key: 'numeroMz', label: 'N°/MZ-LT', type: 'text', placeholder: 'Ej: 123 / MZ A LT 1', maxLength: 10 },
  { key: 'urbanizacion', label: 'URBANIZACIÓN/CASERÍO', type: 'text', placeholder: 'Ej: CHOCÁN, LA ORCA', autoComplete: 'address-line2' },
];

const tipoViaOptions = [
  { value: '', label: 'SELECCIONE...' },
  { value: 'CALLE', label: 'CALLE' },
  { value: 'AV.', label: 'AV.' },
  { value: 'JR.', label: 'JR.' },
  { value: 'TRANSVERSAL', label: 'TRANSVERSAL' },
  { value: 'PASAJE', label: 'PASAJE' },
  { value: 'RURAL', label: 'RURAL' },
  { value: 'BARRIO', label: 'BARRIO' },
  { value: 'OTRO', label: 'OTRO' },
  { value: 'KM', label: 'KM' },
  { value: 'ZONA', label: 'ZONA' },
  { value: 'SECTOR', label: 'SECTOR' },
  { value: 'VÍA', label: 'VÍA' },
  { value: 'PROLONGACIÓN', label: 'PROLONGACIÓN' },
  { value: 'CARRETERA', label: 'CARRETERA' },
  { value: 'ALAMEDA', label: 'ALAMEDA' },
  { value: 'MALECÓN', label: 'MALECÓN' },
];
const formatNombre = (nombre) => {
  return nombre
    .replace(/_/g, ' ')
};

const DireccionFiscal = ({ direccion, peruData, errors, onChange }) => {
  const inputClass = (field) =>
    `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${errors[`direccionFiscal.${field}`] ? 'border-red-500 ring-2 ring-red-100' : 'border-slate-300'
    }`;

  const handleDepartamentoChange = (e) => {
    onChange("direccionFiscal.departamento", e.target.value);
    onChange("direccionFiscal.provincia", "");
    onChange("direccionFiscal.distrito", "");
  };

  const handleProvinciaChange = (e) => {
    onChange("direccionFiscal.provincia", e.target.value);
    onChange("direccionFiscal.distrito", "");
  };

  // Convierte todo texto a mayúsculas para los campos de texto
  const handleUppercaseChange = (name, value) => {
    onChange(name, value.toUpperCase());
  };

  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
        <div className="h-8 w-1.5 rounded-full bg-red-600" />
        <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">DIRECCIÓN FISCAL (DNI)</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {fields.map(({ key, label, type, placeholder, autoComplete, maxLength }) => (
          <div key={key}>
            <label htmlFor={`direccionFiscal-${key}`} className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">{label}</label>
            {type === 'select' ? (
              <select
                id={`direccionFiscal-${key}`}
                name={`direccionFiscal.${key}`}
                value={direccion?.[key] || ''}
                onChange={(e) => onChange(e.target.name, e.target.value)}
                className={inputClass(key)}
                aria-invalid={!!errors[`direccionFiscal.${key}`]}
              >
                {tipoViaOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            ) : (
              <input
                id={`direccionFiscal-${key}`}
                name={`direccionFiscal.${key}`}
                value={direccion?.[key] || ''}
                onChange={e => handleUppercaseChange(e.target.name, e.target.value)}
                placeholder={placeholder}
                autoComplete={autoComplete}
                maxLength={maxLength}
                className={inputClass(key)}
                aria-invalid={!!errors[`direccionFiscal.${key}`]}
                style={{ textTransform: 'uppercase' }}
              />
            )}
            {errors[`direccionFiscal.${key}`] && (
              <p className="mt-1 text-xs font-medium text-red-600">{errors[`direccionFiscal.${key}`]}</p>
            )}
          </div>
        ))}

        {/* Departamento */}
        <div>
          <label htmlFor="direccionFiscal-departamento" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">DEPARTAMENTO</label>
          <select
            id="direccionFiscal-departamento"
            name="direccionFiscal.departamento"
            value={direccion?.departamento || ''}
            onChange={handleDepartamentoChange}
            className={inputClass('departamento')}
            aria-invalid={!!errors['direccionFiscal.departamento']}
          >
            <option value="">SELECCIONE...</option>
            {Object.keys(peruData).map(depto => (
              <option key={depto} value={depto}>{formatNombre(depto)}</option>
            ))}
          </select>
          {errors['direccionFiscal.departamento'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionFiscal.departamento']}</p>
          )}
        </div>

        {/* Provincia */}
        <div>
          <label htmlFor="direccionFiscal-provincia" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">PROVINCIA</label>
          <select
            id="direccionFiscal-provincia"
            name="direccionFiscal.provincia"
            value={direccion?.provincia || ''}
            onChange={handleProvinciaChange}
            disabled={!direccion?.departamento}
            className={inputClass('provincia')}
            aria-invalid={!!errors['direccionFiscal.provincia']}
          >
            <option value="">SELECCIONE...</option>
            {direccion?.departamento &&
              Object.keys(peruData[direccion.departamento]).map(prov => (
                <option key={prov} value={prov}>{formatNombre(prov)}</option>
              ))}
          </select>
          {errors['direccionFiscal.provincia'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionFiscal.provincia']}</p>
          )}
        </div>

        {/* Distrito */}
        <div>
          <label htmlFor="direccionFiscal-distrito" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">DISTRITO</label>
          <select
            id="direccionFiscal-distrito"
            name="direccionFiscal.distrito"
            value={direccion?.distrito || ''}
            onChange={e => onChange(e.target.name, e.target.value)}
            disabled={!direccion?.provincia}
            className={inputClass('distrito')}
            aria-invalid={!!errors['direccionFiscal.distrito']}
          >
            <option value="">SELECCIONE...</option>
            {direccion?.departamento &&
              direccion?.provincia &&
              peruData[direccion.departamento][direccion.provincia].map(dist => (
                <option key={dist} value={dist}>{dist}</option>
              ))}
          </select>
          {errors['direccionFiscal.distrito'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['direccionFiscal.distrito']}</p>
          )}
        </div>
      </div>
      <LocationPickerField
        direccion={direccion}
        fieldPrefix="direccionFiscal"
        errors={errors}
        onChange={onChange}
      />
    </div>
  );
};

export default DireccionFiscal;

